import * as React from "react";
import { TextBox } from "../../atoms/forms/TextBox";

import { ICommonInputsControls } from "./ICommonInputsControls";
import { OrganisatieIcon } from "../../atoms/icons/OrganisatieIcon";

import { useTranslation } from 'react-i18next';



// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControls<string>;
export const OrganisationTextBox = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');

    const label = props.label || tDatatypes('organisatieLabel') || "Organisatie";
    const placeholder = props.placeholder || tDatatypes('organisatiePlaceholder');
    return (<TextBox
            {...props}
            label={label}
            icon={<OrganisatieIcon />}
            placeholder={placeholder}
         />)
}
